import { render, staticRenderFns } from "./RealList.vue?vue&type=template&id=670a2bbb&scoped=true&"
import script from "./RealList.vue?vue&type=script&lang=js&"
export * from "./RealList.vue?vue&type=script&lang=js&"
import style0 from "./RealList.vue?vue&type=style&index=0&id=670a2bbb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a2bbb",
  null
  
)

export default component.exports